module.exports = __webpack_public_path__ + "static/media/psw_inverter.8ee74a7e.jpg";